<template>
    <div>
        <div class="ddMapping__section ddMapping__section--multi">
            <div class="ddMapping__section  f-w-1/1">
                <h4 class="ddMapping__label">
                    SELECTED ITEMS
                </h4>

                <ul class="name-value__list">
                    <li v-for="(val, index) in value" :key="index" class="name-value__item">
                        <div class="f-w-2/3 f-m-0.5">
                            {{ val.name }}
                        </div>
                        <div class="f-w-1/3">
                            <button class="ddMapping__button--small" @click.prevent="moveUp(index)">
                                <font-awesome-icon :icon="['fal', 'arrow-up']" />
                            </button>
                            <button class="ddMapping__button--small" @click.prevent="moveDown(index)">
                                <font-awesome-icon :icon="['fal', 'arrow-down']" />
                            </button>
                            <button class="ddMapping__button--small" @click.prevent="deleteSelectedItem(index)">
                                <font-awesome-icon :icon="['fal', 'trash-alt']" />
                            </button>
                        </div>
                    </li>
                </ul>

                <button
                    class="ddMapping__button f-mt-0.5"
                    @click.prevent="selectItem"
                >
                    Add item
                </button>
            </div>
        </div>


        <button class="ddMapping__button ddMapping__button--wide" @click="search">
            <span :style="{ visibility: isSearching ? 'hidden' : 'visible' }">
                VIEW ITEM DATA
            </span>

            <loading-icon
                v-show="isSearching"
                color="#fff"
                class="ddMapping__button-loading"
            />
        </button>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import {
    SHOW_DRAWER,
} from '@/store/types/mutation-types';
import { drawerHelperMixin } from '@/mixins/drawer-helper';
import LoadingIcon from '@/components/shared/loading/loading-icon';

export default {
    components: {
        LoadingIcon,
    },
    mixins: [drawerHelperMixin],
    props: {
        value: {
            type: Array,
            default: () => ([]),
        },

        isSearching: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...mapState({
            selectedContent: state => state.page.selectedContent,
        }),
    },

    watch: {
        selectedContent(val) {
            if (!val) return;
            this.value.push(val);
        },
    },

    methods: {
        ...mapMutations({
            showDrawer: SHOW_DRAWER,
        }),

        selectItem() {
            this.showDrawer('navigation-tree-content-selector');
        },

        search() {
            this.$emit('search');
        },

        deleteSelectedItem(index) {
            this.value.splice(index, 1);
        },

        moveUp(index) {
            if (index > 0) {
                this.value.splice(index - 1, 0, this.value.splice(index, 1)[0]);
            }
        },

        moveDown(index) {
            if (index < this.value.length) {
                this.value.splice(index + 1, 0, this.value.splice(index, 1)[0]);
            }
        },
    },
};
</script>
